import messages from "../../../../../locale/messages";

const validate = values => {
    let errors = {};

    if(!values.startDate && !values.endDate) errors.date = messages.required;

    return errors;
};

export default validate;